// The sidebar's top: the logo on its tinted tile, with "MSI Lodging" and
// "Reservations" beside it when the sidebar is open. It sat in a soft grey
// card for a while on 2026-10-01; the card was dropped on request.
//
// The look the sidebar had before the 2026-10-01 redesign, restored on
// request: the redesign's bare wordmark at 30px tall was wider than the
// collapsed rail and clipped there. On the tile it is contained, at any width.
import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

const LOGO_SRC = '/images/logo2.png';

export default function SidebarBrand({ expanded }) {
  const tile = expanded ? 46 : 36;
  return (
    <Box sx={{ flex: 1, minWidth: 0, display: 'flex', gap: 1, alignItems: 'center', justifyContent: expanded ? 'flex-start' : 'center', px: expanded ? 1.5 : 1 }}>
      <Box
        sx={(theme) => ({
          width: tile,
          height: tile,
          flexShrink: 0,
          borderRadius: 2.5,
          border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          bgcolor: alpha(theme.palette.primary.main, 0.08),
          display: 'grid',
          placeItems: 'center',
        })}
      >
        <Box component="img" src={LOGO_SRC} alt="MSI Lodging" sx={{ width: '100%', height: '100%', objectFit: 'contain', p: expanded ? 0.6 : 0.5 }} />
      </Box>
      {expanded && (
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant="subtitle2" noWrap sx={{ fontWeight: 700 }}>MSI Lodging</Typography>
          <Typography variant="caption" component="div" noWrap sx={{ color: 'text.secondary' }}>Reservations</Typography>
        </Box>
      )}
    </Box>
  );
}
